import React, { useEffect, useState } from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { notifyError } from 'components/Notify/Notify';

import {
  createOrUpdateTerm,
  createOrUpdateTermFn,
  exportTopicStats,
  getAllTerms,
  getAllTermsFn,
  getMyManagingTerms,
  getMyManagingTermsFn,
  getMyTerms,
  getMyTermsFn,
  exportTopicStatsFn,
} from 'store/pdp/pdpSlice';
import Dropdown from 'components/Dropdown';
import Icon from 'components/Icon';
import { TermEditor } from './TermEditor';
import { IOption } from '../../../../components/Select/Select';
import {
  TermListContainer,
  TermsWrapper,
  TermEditorWrapper,
  BottomSlider,
  BottomSliderChildren,
  TopicWrapper,
} from './style';
import { navigate, RouteComponentProps, useLocation } from '@reach/router';
import { messages } from './Messages';
import Button from '../../../../components/Button/Button';
import { black, blue, red } from '../../../../utils/style/colors';
import LoadingCircleIndicator from '../../../../components/LoadingCircleIndicator/LoadingCircleIndicator';
import Input from '../../../../components/Input/Input';
import { getAccessToken } from '../../../../api/Utils';
import PDPPersonManager from '../PDPPersonManager/PDPPersonManager';
import ClassManager from '../PDPClass/ClassManager';
import ButtonGroup from '../../../../components/ButtonGroup';
import Collapsible from '../../../../components/Collapsible';
import { appDispatch, RootState } from 'store/store';
import { CompanyPDPState, Term } from 'store/pdp/types';
import { ITags, ITagView } from 'store/providers/providerTypes';
import { ICompany, ICompanyRole } from 'store/companies/companiesTypes';
import { isCompanyOwnerOrSupport } from 'store/companies/companiesUtils';
import moment from 'moment-jalaali';
import APopover from '../../../../components/APopover';
import HoverIcon from '../../../../components/HoverIcon';
import { changeStateOFSideBar, isMobile } from '../../../../store/app/appSlice';
import { Spinner } from '../../../../components/Button/style';
import IconTypes from '../../../../components/Icon/IconTypes';
import MyClassOverview from '../PDPClass/MyClassOverview';
import { IThisUser } from '../../../../store/thisUser/thisUserSlice';
import ClassListView from '../PDPClass/ClassListView';
import { addGuideToList } from '../../../../store/siteGuide/SiteGuideSlice';
import { useSafeNavigate } from '../../../../context/SafeNavigate/SafeNavigateProvider';

const { Menu, MenuItem } = Dropdown;

interface StateToProps {
  pdpState: CompanyPDPState;
  tags: ITags['data'];
  company: ICompany;
  isPDPAdmin: boolean;
  accessToken?: string;
  thisUser: IThisUser;
}

interface DispatchToProps {
  addORUpdateTerm: (topic: Term) => ReturnType<typeof createOrUpdateTermFn>;
  getAllTerms: (
    pdpId: number,
    includeDeleted: boolean
  ) => ReturnType<typeof getAllTermsFn>;
  getMyManagingTerms: (
    pdpId: number
  ) => ReturnType<typeof getMyManagingTermsFn>;
  getMyTerms: (pdpId: number) => ReturnType<typeof getMyTermsFn>;
  exportTopicStats: (
    termIds: number[]
  ) => ReturnType<typeof exportTopicStatsFn>;
  changeStateOfSideBar: (isSideBarCollapsed: boolean) => any;
}
interface IOwnProps {
  companyId?: number;
  termId?: string;
  page?: string;
  classId?: string;
  pdpId?: string;
  children?: React.ReactNode;
}
type ComponentProps = StateToProps &
  DispatchToProps &
  IOwnProps &
  RouteComponentProps;
const TermManager: React.FC<ComponentProps> = ({
  addORUpdateTerm,
  company,
  getAllTerms: doGetAllTerms,
  getMyManagingTerms: doGetMyManagingTerms,
  getMyTerms: doGetMyTerms,
  isPDPAdmin,
  pdpState,
  tags,
  accessToken,
  page,
  termId,
  classId,
  changeStateOfSideBar,
  exportTopicStats,
  children,
  thisUser,
  pdpId,
}) => {
  const { notifyUnsavedChanges, navigateWithConfirmation } = useSafeNavigate();
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState({});
  const [exporting, setExporting] = useState({});
  const [showDeleted, setShowDeleted] = useState(false);
  const [selectedTerm, setSelectedTermInternal] = useState(
    null as number | null
  );
  const setSelectedTerm = (termId: number | null) => {
    setSelectedTermInternal(termId);
    changeStateOfSideBar(true);
  };
  const location = useLocation();
  const menuItems = [
    {
      title: messages.topics,
      link: `/t/${company.id}/pdp/${pdpId}/terms/topics`,
      iconName: 'list',
    },
    {
      title: messages.documents,
      link: `/t/${company.id}/pdp/${pdpId}/terms/documents`,
      iconName: 'folder',
    },
  ];
  // const [editingTerm, setEditingTerm] = useState(false);
  useEffect(() => {
    if (Object.keys(terms || {}).length === 0) setLoading(true);
    const requests = [] as Promise<any>[];
    if (isPDPAdmin) requests.push(doGetAllTerms(Number(pdpId)!, showDeleted));
    else {
      requests.push(doGetMyManagingTerms(Number(pdpId!)));
      requests.push(doGetMyTerms(Number(pdpId!)));
    }
    Promise.all(requests).finally(() => {
      setLoading(false);
    });
  }, [showDeleted]);

  useEffect(() => {
    if (termId === 'new') setSelectedTerm(-1);
    else if (termId === 'calendar') {
      /*do nothing*/
    } else setSelectedTerm(Number(termId) || null);
  }, [termId, page]);

  const allRoles = Object.values(company.roles) as ICompanyRole[];
  const allRoleOptions =
    allRoles
      ?.filter((it) => !it.isProjectRole)
      ?.map((it) => ({ value: it.id, label: it.displayName! })) || [];
  const tagOptions: IOption[] = [];
  const selectedPpdPanel = company.pdpPanels.find(
    (companyPdp) => companyPdp.id === Number(pdpId)
  )!;
  Object.values(tags).forEach((it: ITagView) => {
    if (
      it.parentId &&
      (selectedPpdPanel.properties.topicTags.includes(it.parentId) ||
        selectedPpdPanel.properties.topicTagsInPDP.includes(it.parentId))
    ) {
      tagOptions.push({
        value: it.id,
        label: it.text,
        parent: it.parentId,
      });
    } else if (
      selectedPpdPanel.properties.topicTags.includes(Number(it.id)) ||
      selectedPpdPanel.properties.topicTagsInPDP.includes(Number(it.id))
    ) {
      tagOptions.push({
        value: it.id,
        label: it.text,
        disabled: true,
      });
    }
  });
  const terms = Object.values(pdpState?.terms || {}).sort((a, b) => {
    return (b.term?.startDate || 1e100) - (a.term?.startDate || 1e100);
  });
  const termsWithStartDate = terms.filter((it) => !!it.term?.startDate);
  const termsWithoutStartDate = terms.filter(
    (it) => !!it.term && !it.term.startDate
  );
  const set = new Set(
    termsWithStartDate.map((it: any) => {
      const m = moment(it.term.startDate);
      return m.format('jYYYY');
    })
  );
  const foundYears = Array.from(set).sort().reverse();
  if (termsWithoutStartDate.length > 0) {
    foundYears.push('Others');
  }
  const currentYear = moment().format('jYYYY');
  useEffect(() => {
    if (
      !loading &&
      !page &&
      !location.pathname.endsWith(`pdp/${pdpId}/terms/documents`) &&
      !location.pathname.endsWith(`pdp/${pdpId}/terms/topics`) &&
      foundYears.includes(currentYear)
    ) {
      navigateWithConfirmation?.(
        `/t/${company.id}/pdp/${selectedPpdPanel.id}/terms/calendar/${currentYear}`
      );
    }
  }, [pdpState?.terms, loading]);

  useEffect(() => {
    appDispatch(addGuideToList(['ثبت نیازسنجی آموزشی']));
  }, []);
  if (loading)
    return (
      <div>
        <LoadingCircleIndicator />
      </div>
    );
  const term = terms.find((it) => it.term?.id === selectedTerm)?.term;

  const exportTopicStatsHandler = (termIds: number[], year: string) => {
    setExporting({ ...exporting, [year]: true });
    exportTopicStats(termIds)
      .catch((e: any) => {
        notifyError(e);
      })
      .finally(() => {
        setExporting({ ...exporting, [year]: false });
      });
  };
  function getGoBack() {
    let ret = selectedTerm ? '../../' : '../';
    if (classId) ret = ret + '../';
    return ret;
  }

  const termPages = [
    {
      title: messages.requests,
      link: './req',
    },
    {
      title: messages.courses,
      link: './class',
    },
    {
      title: messages.result,
      link: './result',
    },
  ];
  if (isPDPAdmin)
    termPages.splice(0, 0, {
      title: messages.settings,
      link: './edit',
    });

  return (
    <TermsWrapper>
      <TermListContainer className={selectedTerm && 'hide-on-mobile'}>
        {isPDPAdmin && (
          <div
            className="hide-on-mobile"
            style={{
              margin: '1em',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button
              onClick={() => {
                navigateWithConfirmation?.(
                  `/t/${company.id}/pdp/${selectedPpdPanel.id}/terms/new/edit`
                );
              }}
            >
              {messages.addTerm}
            </Button>
            <APopover
              arrow={true}
              curveBorder={true}
              target={
                <div>
                  <HoverIcon color={'white'} type={'more-vertical'} />
                </div>
              }
              trigger="click"
            >
              <div>
                <Input
                  id="showDeleted"
                  type="checkbox"
                  checked={showDeleted}
                  wrapperStyle={{ marginTop: '10px' }}
                  onChange={(e) => {
                    setShowDeleted(e.target.checked);
                  }}
                  label={messages.showDeleted}
                />
              </div>
            </APopover>
          </div>
        )}
        <div style={{ flex: 1, overflow: 'auto' }}>
          {foundYears.map((year, index) => {
            return (
              <Collapsible
                // noColor={true}
                nested={true}
                customHeaderStyle={{
                  flexGrow: 1,
                }}
                key={year}
                header={
                  <div
                    style={{
                      display: 'flex',
                      flexGrow: 1,
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>
                      {year === 'Others'
                        ? messages.others
                        : messages.termYear(year)}
                    </div>
                    {isPDPAdmin && (
                      <div>
                        <Dropdown
                          curveBorder={true}
                          marginToTarget={4}
                          placement="bottom"
                          onShowChange={(e) => {
                            setShowDropdown({ ...showDropdown, [year]: e });
                          }}
                          show={showDropdown[year]}
                          usePortal={true}
                          target={
                            <div>
                              <HoverIcon
                                color={'var(--exact-white)'}
                                type={'more-vertical'}
                              />
                            </div>
                          }
                        >
                          <Menu>
                            <MenuItem>
                              <a
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  exportTopicStatsHandler(
                                    (year === 'Others'
                                      ? termsWithoutStartDate.filter(
                                          (it) =>
                                            it.term?.id &&
                                            (!it.term.deleted || showDeleted)
                                        )
                                      : terms.filter(
                                          (it) =>
                                            it.term?.id &&
                                            it.term.startDate &&
                                            moment(it.term.startDate).format(
                                              'jYYYY'
                                            ) === year &&
                                            (!it.term.deleted || showDeleted)
                                        )
                                    ).map((it) => it.term?.id || 0),
                                    year
                                  );
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  {!exporting[year] ? (
                                    <Icon
                                      type={'bar-chart'}
                                      style={{
                                        width: '18px',
                                        height: '18px',
                                        margin: '5px',
                                      }}
                                    />
                                  ) : (
                                    <Spinner
                                      viewBox="0 0 128 128"
                                      style={{ margin: '5px' }}
                                    >
                                      <path
                                        className="path"
                                        d="M75.4 126.6a11.4 11.4 0 0 1-2.1-22.6 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.3 4.9h0a63.8 63.8 0 0 1-47.8 48.1v0a11.4 11.4 0 0 1-2.9z"
                                      />
                                    </Spinner>
                                  )}
                                  {messages.exporTopicStats}
                                </div>
                              </a>
                            </MenuItem>
                          </Menu>
                        </Dropdown>
                      </div>
                    )}
                  </div>
                }
                customBodyStyle={{
                  padding: 'unset',
                  paddingRight: '1em',
                  // border: '2px solid ${exactWhite}',
                }}
                customCollapsibleHeaderStyle={
                  {
                    // backgroundColor: exactWhite,
                    // border: `1px solid ${exactWhite}`,
                    // color: black,
                  }
                }
                style={{
                  margin: '2px',
                }}
                defaultOpen={(() => {
                  const termOpen = terms.find(
                    (it) => it.term?.id === selectedTerm
                  )?.term;
                  return (
                    !index ||
                    page === year ||
                    !!(
                      !!selectedTerm &&
                      ((!termOpen?.startDate && page === 'Others') ||
                        (termOpen?.startDate &&
                          moment(termOpen?.startDate).format('jYYYY') === year))
                    )
                  );
                })()}
              >
                <BottomSliderChildren
                  selected={page === year}
                  onClick={() => {
                    navigateWithConfirmation?.(
                      `/t/${company.id}/pdp/${selectedPpdPanel.id}/terms/calendar/${year}`
                    );
                  }}
                >
                  <Icon type={'calendar'} style={{ paddingLeft: '0.5rem' }} />
                  {messages.calendar}
                </BottomSliderChildren>
                {(year === 'Others'
                  ? termsWithoutStartDate.filter(
                      (it) => it.term?.id && (!it.term.deleted || showDeleted)
                    )
                  : terms.filter(
                      (it) =>
                        it.term?.id &&
                        it.term.startDate &&
                        moment(it.term.startDate).format('jYYYY') === year &&
                        (!it.term.deleted || showDeleted)
                    )
                ).map((it) => {
                  const selected = it.term?.id === selectedTerm;
                  return (
                    <>
                      <Collapsible
                        noColor={true}
                        style={{
                          // borderRight: '1px solid white',
                          // borderRadius: 0,
                          marginLeft: '10px',
                        }}
                        customBodyStyle={{
                          padding: 'unset',
                          paddingRight: '1em',
                        }}
                        key={it.term?.id}
                        // onClick={() => {
                        //   // setSelectedTerm(it.term.id!);
                        //   if (selected) return;
                        //   const goBack = getGoBack();
                        //   const now = new Date().getTime();
                        //   const beforeSomePDPPhase =
                        //     it.term.properties.phaseConfig.phases.some(
                        //       (it) => it.endDate >= now
                        //     );
                        //   navigate(
                        //     `${goBack}terms/${it.term.id!}/${
                        //       beforeSomePDPPhase ? 'req' : 'class'
                        //     }`
                        //   );
                        //   // setEditingTerm(false);
                        // }}
                        // style={{
                        //   backgroundColor: selected ? lightGreenSolid : undefined,
                        // }}
                        header={
                          <span
                            style={{
                              transition: 'all 700ms',
                              margin: selected ? '0 auto 10px' : '0',
                            }}
                          >
                            {it.term?.properties?.name}
                            {it.term?.deleted && (
                              <span style={{ color: red }}>
                                {' '}
                                ({messages.deleted})
                              </span>
                            )}
                          </span>
                        }
                        isOpen={selected ? true : undefined}
                      >
                        <span
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            cursor: selected ? 'default' : 'pointer',
                          }}
                        >
                          {
                            <ButtonGroup
                              items={(it.term?.properties.disableNeedAssessment
                                ? termPages.filter(
                                    (item) => item.link !== './req'
                                  )
                                : termPages
                              ).reduce((current, item) => {
                                current[item.link] = item.title;
                                return current;
                              }, {})}
                              selected={`./${page}${selected ? '' : 'other'}`}
                              onSelect={(url) => {
                                navigateWithConfirmation?.(
                                  `/t/${company.id}/pdp/${selectedPpdPanel.id}/terms/${it.term?.id}/${url}`
                                );
                              }}
                              vertical={true}
                              colors={{
                                selectedBackgroundColor: blue,
                                backgroundColor: 'unset',
                                // selectedTextColor: white,
                                // textColor: white,
                              }}
                            />
                          }
                        </span>
                      </Collapsible>
                    </>
                  );
                })}
              </Collapsible>
            );
          })}
        </div>
        {isPDPAdmin && (
          <BottomSlider>
            {menuItems.map((value, ind) => {
              return (
                <BottomSliderChildren
                  key={ind}
                  selected={value.link === location.pathname && true}
                  onClick={() => {
                    navigateWithConfirmation?.(value.link);
                  }}
                >
                  <Icon
                    type={value.iconName as IconTypes}
                    style={{ paddingLeft: '0.5rem' }}
                  />
                  {value.title}
                </BottomSliderChildren>
              );
            })}
          </BottomSlider>
        )}
      </TermListContainer>
      {location.pathname.startsWith(
        `/t/${company.id}/pdp/${selectedPpdPanel.id}/terms/calendar`
      ) ? (
        pdpState && (
          <TermEditorWrapper>
            <ClassListView
              pdpState={pdpState}
              company={company}
              isPdpAdmin={isPDPAdmin}
              thisUserId={Number(thisUser.userId)}
              tags={tags}
              year={Number(page) || page || currentYear}
              selectedPdpPanel={selectedPpdPanel}
              handleClickOnClass={() => {
                /*todo*/
              }}
            />
          </TermEditorWrapper>
        )
      ) : location.pathname ===
        `/t/${company.id}/pdp/${pdpId}/terms/documents` ? (
        <>{children}</>
      ) : location.pathname === `/t/${company.id}/pdp/${pdpId}/terms/topics` ? (
        <TopicWrapper style={{}}>{children}</TopicWrapper>
      ) : selectedTerm ? (
        <TermEditorWrapper style={{ marginRight: '0px !important' }}>
          <HoverIcon
            type={'x-circle'}
            color={black}
            style={{
              position: 'absolute',
              top: '-0px',
              left: '-0px',
              zIndex: 100,
              backgroundColor: 'var(--exact-white)',
              borderRadius: '50%',
            }}
            size={'25px'}
            onClick={() => {
              const result = notifyUnsavedChanges?.();
              if (isMobile() && result) {
                history.back();
              } else if (result) {
                navigate(getGoBack() + 'terms');
              }
            }}
          />
          {page === 'edit' ? (
            <TermEditor
              editable={isPDPAdmin && !term?.deleted}
              new={selectedTerm === -1}
              term={term}
              allRoleOptions={allRoleOptions}
              selectTagOptions={tagOptions}
              createOrUpdateTerm={(term) => {
                const termPromise = addORUpdateTerm(term);
                termPromise.then(({ term }: any) => {
                  setSelectedTerm(term.id || -1);
                  return term;
                });
                return termPromise;
              }}
              allTags={tags}
              pdpId={Number(pdpId)!}
              company={company}
              token={accessToken}
              getAllClassesInTerm={() => {
                return {} as any;
              }}
              getMyClassesInTerm={() => {
                return {} as any;
              }}
              getAllPDPInTerm={() => {
                return {} as any;
              }}
              terms={terms}
            />
          ) : page === 'req' ? (
            <PDPPersonManager
              termId={selectedTerm.toString()}
              companyId={company.id}
              pdpId={Number(pdpId)!}
            />
          ) : page === 'class' ? (
            <ClassManager
              companyId={company.id}
              termId={selectedTerm.toString()}
              classId={classId}
              pdpId={Number(pdpId)!}
            />
          ) : page === 'result' ? (
            <MyClassOverview
              termId={Number(termId)}
              companyPDP={company.pdpPanels.find(
                (el) => el.id === Number(pdpId)
              )}
              pdpState={pdpState}
              defaultUserId={isPDPAdmin ? undefined : Number(thisUser.userId)}
              thisUserId={Number(thisUser.userId)}
              companyId={company.id}
              isAdmin={isPDPAdmin}
              pdpId={Number(pdpId)!}
            />
          ) : (
            <div />
          )}
        </TermEditorWrapper>
      ) : (
        <div style={{ margin: 'auto' }} className={'hide-on-mobile'}>
          {messages.selectATerm}
        </div>
      )}
    </TermsWrapper>
  );
};

const mapStateToProps: MapStateToProps<StateToProps, IOwnProps, RootState> = (
  state,
  ownProps
) => {
  const providerIds = Object.values(state.providers.map).reduce(
    (current: number[], it) => {
      if (it.data?.managingCompanyId === Number(ownProps.companyId))
        current.push(it.data!.id);
      return current;
    },
    [] as number[]
  );
  let tags: ITags['data'] = {};
  const toLoadTags = [] as number[];
  providerIds.forEach((id: number) => {
    if (!state.providers?.tags[id]?.status) toLoadTags.push(id);
    tags = {
      ...tags,
      ...state.providers.tags[id]?.data,
    };
  });
  const companyView = state.companies.data[Number(ownProps.companyId)];
  const company = companyView;
  const thisUserView = state.thisUser;
  const thisUser = thisUserView;
  const member = company.members[Number(thisUser.userId)];
  const selectedCompanyPdp = company.pdpPanels.find(
    (el) => el.id === Number(ownProps.pdpId)
  )!;
  const isPDPAdmin = Boolean(
    isCompanyOwnerOrSupport(thisUserView, companyView) ||
      (selectedCompanyPdp.managerRoleId &&
        member.roles[selectedCompanyPdp.managerRoleId])
  );
  const token = getAccessToken(state);

  return {
    isPDPAdmin,
    company,
    tags: tags,
    accessToken: token,
    pdpState: state.pdp.pdpMap[Number(ownProps.pdpId)!],
    thisUser: thisUser as any,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  IOwnProps
> = () => {
  return {
    addORUpdateTerm: (topic: Term) =>
      appDispatch(createOrUpdateTerm({ term: topic })),
    getAllTerms: (pdpId: number, includeDeleted: boolean) =>
      appDispatch(getAllTerms({ pdpId, includeDeleted })),
    getMyManagingTerms: (pdpId: number) =>
      appDispatch(getMyManagingTerms({ pdpId })),
    getMyTerms: (pdpId: number) => appDispatch(getMyTerms({ pdpId })),
    exportTopicStats: (termIds: number[]) =>
      appDispatch(exportTopicStats({ termIds })),
    changeStateOfSideBar: (isSideBarCollapsed: boolean) =>
      appDispatch(changeStateOFSideBar({ isCollapsed: isSideBarCollapsed })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TermManager);
